import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import { MdMenu } from "react-icons/md";
import { getAdminRoutesByRole } from "routes/adminRoutes";
import { getCurrentBackendRole } from "utils/auth";
import NotificationsPage from "views/notifications";
import SessionReportPage from "views/admin/sessions/SessionReportPage";
import ReportTemplateList from "views/admin/report-templates";
import UserProfileReadonly from "views/admin/users-management/UserProfileReadonly";

export default function Admin() {
  const [open, setOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const backendRole = getCurrentBackendRole();
  const routes = React.useMemo(() => getAdminRoutesByRole(backendRole), [backendRole]);

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar
        open={open}
        collapsed={collapsed}
        onClose={() => setOpen(false)}
        onToggleCollapse={() => setCollapsed((c) => !c)}
        routes={routes}
      />
      {/* Main Content */}
      <div className="h-full w-full bg-canvas">
        <main
          className={`mx-[12px] h-full flex-none transition-all duration-300 md:pr-2 ${
            collapsed ? "xl:ml-[92px]" : "xl:ml-[292px]"
          }`}
        >
          <div className="flex flex-col h-full">
            {/* Mobile hamburger */}
            <div className="flex items-center pt-4 px-2 xl:hidden">
              <button
                onClick={() => setOpen(true)}
                className="flex items-center justify-center h-10 w-10 rounded-lg text-ink hover:bg-surface-hover transition-colors"
              >
                <MdMenu className="h-5 w-5" />
              </button>
            </div>
            <div className="flex-1 p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/sessions/:sessionId/reports" element={<SessionReportPage />} />
                <Route path="/report-templates/manage" element={<ReportTemplateList />} />
                <Route path="/users/:userId/profile" element={<UserProfileReadonly />} />

                {/* Backward-compatible aliases after merging staff + students into users */}
                <Route
                  path="/staff"
                  element={<Navigate to="/admin/users" replace />}
                />
                <Route
                  path="/data-tables"
                  element={<Navigate to="/admin/users" replace />}
                />

                <Route
                  path="/"
                  element={
                    <Navigate
                      to={backendRole === "TEACHER" || backendRole === "TRAINER" ? "/admin/classes-mgmt" : "/admin/dashboard"}
                      replace
                    />
                  }
                />
              </Routes>
            </div>
            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
}
